import { useParams } from "react-router";

/**
 * Retrieves the value of the specified URL parameter.
 * Throws an error if the parameter is missing.
 * Use this hook only when the parameter is required at the place of use.
 *
 * @param paramKey - The key of the URL parameter to retrieve.
 * @returns The value of the URL parameter.
 * @throws An error if the specified parameter is not present in the URL.
 */
export function useParamOrThrow(paramKey: string): string {
  const { [paramKey]: param } = useParams<{ [key: string]: string }>();
  if (!param) throw new Error(`Param ${paramKey} is required`);
  return param;
}
